import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import React from 'react';
import { DivProps } from 'typings';
import PlayerCardHeader from './player-card-header';
import { CardContainer } from './styles';

type Props = {
  teamId: number;
  player: TeamPlayer;
  containerProps?: Omit<DivProps, 'children'>;
  index: number;
};

const PlayersComponentsPlayerCard = (props: Props) => {
  const { teamId, player, index, containerProps } = props;

  return (
    <CardContainer className="mb-4 last:mb-0">
      <PlayerCardHeader teamId={teamId} player={player} containerProps={containerProps} index={index} />
    </CardContainer>
  );
};

export default PlayersComponentsPlayerCard;
